/*!
 * hero-intro.js — Logo Knockout Reveal (SVG)
 * Runs on every home-page load (no session gate).
 * Requires GSAP 3 (loaded from CDN if not already present).
 */
(function () {
  'use strict';

  var FALLBACK_MS = 4000;
  var GSAP_CDN    = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';

  var overlay = document.getElementById('hero-intro');
  if (!overlay) return;

  var cfg      = window.__heroIntroConfig || {};
  var logoSel  = overlay.dataset.logoSelector || cfg.logoSelector || '.header-logo';
  var ctaSel   = overlay.dataset.ctaSelector  || cfg.ctaSelector  || '.hero__content-wrapper .button';
  var mediaSel = '.hero__media, .hero__media-wrapper, .slideshow__slide--media';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finish(true);
    return;
  }

  document.documentElement.classList.add('intro-lock');

  var fallbackId = setTimeout(function () { finish(true); }, FALLBACK_MS);

  loadGSAP(run);

  function run() {
    var gsap = window.gsap;
    if (!gsap) { finish(true); return; }

    var logoWrap = overlay.querySelector('.hero-intro__logo-wrap');
    var logoEl   = document.querySelector(logoSel);
    var ctaEl    = document.querySelector(ctaSel);
    var mediaEl  = document.querySelector(mediaSel);

    if (!logoWrap) { finish(true); return; }

    if (logoEl)  gsap.set(logoEl,  { autoAlpha: 0 });
    if (ctaEl)   gsap.set(ctaEl,   { autoAlpha: 0, y: 28 });
    if (mediaEl) gsap.set(mediaEl, { scale: 1.06 });

    var logoRect  = logoEl ? logoEl.getBoundingClientRect() : null;
    var srcRect   = logoWrap.getBoundingClientRect();
    var hasTarget = logoRect
                    && srcRect.width  > 0 && srcRect.height  > 0
                    && logoRect.width > 0 && logoRect.height > 0;

    var targetScale = 0.1;
    var targetX = 0;
    var targetY = 0;

    if (hasTarget) {
      var scaleByH = logoRect.height / srcRect.height;
      var scaleByW = logoRect.width  / srcRect.width;
      targetScale  = Math.min(scaleByH, scaleByW, 0.3);
      targetScale  = Math.max(targetScale, 0.04);
      targetX = (logoRect.left + logoRect.width  / 2) - (srcRect.left + srcRect.width  / 2);
      targetY = (logoRect.top  + logoRect.height / 2) - (srcRect.top  + srcRect.height / 2);
    }

    var tl = gsap.timeline({ onComplete: onDone });

    tl.fromTo(logoWrap,
      { opacity: 0, scale: 0.72 },
      { opacity: 1, scale: 1, duration: 0.65, ease: 'back.out(1.5)' },
      0.06
    );

    tl.addLabel('peak');

    if (hasTarget) {
      tl.addLabel('fly', 'peak+=0.45');

      tl.to(logoWrap, {
        scale: targetScale, x: targetX, y: targetY,
        duration: 0.65, ease: 'power2.inOut',
      }, 'fly');

      if (mediaEl) {
        tl.to(mediaEl, { scale: 1, duration: 1.1, ease: 'expo.out' }, 'fly');
      }

      tl.to(overlay, { opacity: 0, duration: 0.5, ease: 'power2.inOut' }, 'fly+=0.3');

      if (logoEl) {
        tl.to(logoEl, { autoAlpha: 1, duration: 0.4, ease: 'power2.out' }, 'fly+=0.4');
      }
      if (ctaEl) {
        tl.to(ctaEl, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'back.out(1.5)' }, 'fly+=0.52');
      }

    } else {
      if (mediaEl) {
        tl.to(mediaEl, { scale: 1, duration: 1.0, ease: 'expo.out' }, 'peak');
      }
      tl.to(overlay, { opacity: 0, duration: 0.65, ease: 'power2.inOut' }, 'peak+=0.55');
      if (ctaEl) {
        tl.to(ctaEl, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'back.out(1.5)' }, 'peak+=0.7');
      }
    }
  }

  function onDone() {
    clearTimeout(fallbackId);
    var gsap = window.gsap;
    if (gsap) {
      [logoSel, ctaSel, mediaSel].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) gsap.set(el, { clearProps: 'all' });
      });
    }
    finish(false);
  }

  function finish(immediate) {
    clearTimeout(fallbackId);
    overlay.classList.add('is-done');
    document.documentElement.classList.remove('intro-lock');
    if (immediate) {
      [logoSel, ctaSel, mediaSel].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        if (window.gsap) {
          window.gsap.set(el, { clearProps: 'all' });
        } else {
          ['opacity', 'visibility', 'transform'].forEach(function (p) {
            el.style.removeProperty(p);
          });
        }
      });
    }
  }

  function loadGSAP(cb) {
    if (window.gsap) { cb(); return; }
    var s = document.createElement('script');
    s.src = GSAP_CDN;
    s.crossOrigin = 'anonymous';
    s.referrerPolicy = 'no-referrer';
    s.onload  = cb;
    s.onerror = function () { clearTimeout(fallbackId); finish(true); };
    document.head.appendChild(s);
  }

})();
